'use strict';

var _typeof = require('./typeof.js');
var assertThisInitialized = require('./assertThisInitialized.js');

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
